import { useQuery } from '@tanstack/react-query';
import { Project } from '../../../types/projects';
import { genericDocumentApi } from '../../../api/generic-documents';
import { DocumentsSection } from '../../../components/DocumentsSection';

/**
 * Was a permanent placeholder claiming Azure Blob Storage was never
 * provisioned - that block only applied to DocumentEngine.uploadToBlob(),
 * a method the generic Documents system (built for Tracking/Documents/
 * Comments rollout) never calls: it stores files as inline base64 in
 * documents.file_data, the same technique already proven for employee
 * documents. This tab now genuinely uploads, lists, downloads, and
 * deletes project documents - not a description of a future feature.
 */
export function ProjectDocumentsTab({ project }: { project: Project }) {
  const docsQuery = useQuery({ queryKey: ['project-documents', project.id], queryFn: () => genericDocumentApi.listFor('project', project.id) });

  return (
    <DocumentsSection
      documents={docsQuery.data?.data ?? []}
      downloadUrl={(documentId) => genericDocumentApi.downloadUrl('project', documentId)}
      upload={(input) => genericDocumentApi.uploadFor('project', project.id, input)}
      onDelete={(documentId) => genericDocumentApi.deleteFor('project', documentId)}
      queryKeyToInvalidate={['project-documents', project.id]}
      hrCategories={false}
    />
  );
}
